var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame1261153743AboutUsPg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 110,
    viewBox: "0 0 106 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5389 125.711C64.1698 129.628 61.5001 133.364 57.5343 133.486C47.8202 133.783 38.1519 131.534 29.5135 126.902C18.7549 121.133 10.1902 111.988 5.13766 100.875C0.0850767 89.7614 -1.17542 77.2958 1.55016 65.3961C4.27574 53.4964 10.8363 42.8222 20.2223 35.0161C29.6082 27.2101 41.2994 22.7048 53.4965 22.1936C65.6936 21.6825 77.7207 25.1938 87.7269 32.1871C97.7331 39.1805 105.164 49.2684 108.875 60.8983C111.856 70.2362 112.306 80.1526 110.242 89.6497C109.4 93.5269 105.24 95.471 101.503 94.1368C97.7667 92.8026 95.8869 88.6908 96.5545 84.7797C97.6615 78.2938 97.209 71.6009 95.1875 65.2668C92.4336 56.6378 86.9203 49.1529 79.496 43.964C72.0717 38.7752 63.148 36.1699 54.0981 36.5491C45.0483 36.9284 36.3738 40.2712 29.4097 46.063C22.4456 51.8549 17.5779 59.7748 15.5556 68.604C13.5333 77.4332 14.4686 86.6823 18.2174 94.9279C21.9663 103.173 28.321 109.959 36.3035 114.239C42.1631 117.381 48.6615 119.046 55.2405 119.139C59.2077 119.196 62.9081 121.794 63.5389 125.711Z",
    fill: "url(#paint0_linear_2224_29295)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.749 133.644C108.017 135.533 95.989 133.515 85.5164 127.899C75.0439 122.283 66.707 113.382 61.7888 102.564C56.8706 91.7465 55.6437 79.6124 58.2968 68.0292C60.9498 56.446 67.336 46.0557 76.4723 38.4572C85.6086 30.8587 96.9888 26.4733 108.862 25.9757C120.734 25.4781 132.442 28.8961 142.182 35.7035C151.922 42.5108 159.155 52.3304 162.768 63.651C166.381 74.9716 166.173 87.1658 162.177 98.357L156.959 96.4939C160.547 86.4467 160.733 75.499 157.489 65.3356C154.246 55.1722 147.752 46.3564 139.008 40.2449C130.263 34.1334 119.753 31.0648 109.094 31.5115C98.4345 31.9582 88.2176 35.8954 80.0152 42.7171C71.8128 49.5389 66.0794 58.8671 63.6976 69.2662C61.3157 79.6654 62.4172 90.5591 66.8327 100.271C71.2481 109.983 78.7328 117.974 88.1348 123.016C97.5368 128.058 108.335 129.87 118.868 128.174L119.749 133.644Z",
    fill: "url(#paint1_linear_2224_29295)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2224_29295",
    x1: 46.9749,
    y1: 22.8531,
    x2: 64.6811,
    y2: 132.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B43EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C056C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2224_29295",
    x1: 34.7832,
    y1: 147.68,
    x2: 60.5413,
    y2: 3.01219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1261153743AboutUsPg);
export default __webpack_public_path__ + "static/media/frame_1261153743_aboutUs_pg.d835aa7a1c75b0add4f70da132a101b7.svg";
export { ForwardRef as ReactComponent };